import { CommonRequest, Method, ServiceName, CommonResponse } from 'models/common/RestApi';
import { SetupExcpParam, PackingList } from 'models/setup/excp/excp';
import { callApi } from 'utils/ApiUtil';

export const getSetupShipmentList = async (condition: SetupExcpParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/packingList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<PackingList[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as PackingList[];
};

export const saveShipmentList = async (condition: PackingList) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/saveSetupCtnr`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: condition,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

export const getProjectShipmentCnt = async (condition: SetupExcpParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: '/v1/setup/packingListCnt',
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<SetupExcpParam> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupExcpParam;
};
